import Link from "next/link";

export default function NavLink(props) {
  const { dark = false, ...rest } = props;
  return (
    <Link href={props.href} passHref>
      <a
        className={`${
          dark
            ? "lg:text-white lg:hover:text-blueGray-200"
            : "hover:text-blueGray-500"
        } text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold`}
        {...rest}
      >
        {props.children}
      </a>
    </Link>
  );
}
